/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: MyLabelPrecompiledFactory.ts
 * Project: mle-client-n
 * Committed last: 2022/11/25 @ 938
 * ---
 * Description:
 */

import {
    AbstractPrecompiledFactory,
    PrecompiledBase,
    PrecompiledBaseInput
} from "../abstract/AbstractPrecompiledFactory";
import Pamela from "@revodigital/pamela";
import {ShapeTypes} from "../../../../../../common/enums";
import {ShapeFactory} from "../shape/ShapeFactory";

export interface MyLabelPrecompiledFieldInput extends PrecompiledBaseInput {
    shapeType: ShapeTypes;
    prefix?: string;
    suffix?: string;
}

export interface MyLabelPrecompiledField extends PrecompiledBase {
    shapeType: ShapeTypes;
    prefix?: string;
    suffix?: string;
}

/**
 * Factory per creare i precompilati MyLabel
 */
export class MyLabelPrecompiledFieldFactory extends AbstractPrecompiledFactory<MyLabelPrecompiledField> {
    private _shapeFactory = new ShapeFactory();

    constructor(index: MyLabelPrecompiledField[]) {
        super(index);
    }

    produce(data: MyLabelPrecompiledField): Pamela.Shape | undefined {
        const text = `${data.prefix || ''}${data.fieldName}${data.suffix || ''}`

        switch (data.shapeType) {
            case ShapeTypes.RICH_TEXT:
                return this._shapeFactory.produceRichText(text);
            case ShapeTypes.TEXT:
                return this._shapeFactory.produceSimpleText(text);
            default:
                return undefined;
        }
    }
}